var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'app-wrapper': true, ai_stick_bg: !_vm.APP_IN_BROWSER }},[_c('div',{attrs:{"id":"app"}},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }